module.exports = "/images/SC.png?a44a60f41ea5dfa40d074761c5f845ac";